const BACK_TO_LOGIN_LABEL = "Revenir à la connexion";

type BackToLoginButtonProps = { onClick: () => void };

// Leaves the security step without any account change: the next login
// starts the verification again.
export const BackToLoginButton = ({ onClick }: BackToLoginButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    className="text-sm text-gray-500 hover:text-primary dark:text-gray-400"
    data-testid="back-to-login-button"
  >
    {BACK_TO_LOGIN_LABEL}
  </button>
);

BackToLoginButton.displayName = "BackToLoginButton";
